import React, { Component } from 'react';

export default class LeaseRentalHeader extends Component {
 constructor(props) {
  super(props);
 }
 render() {
  return (
   <thead>
    <tr>
     <th> Type</th>
     <th> Currency</th>
     <th> Interval</th>
     <th> Amount</th>
     <th> Escalation Percentage</th>
     <th>Start Date</th>
     <th>End Date</th>
     <th></th>

    </tr>
   </thead>
  )
 }
}